import React from 'react';

const LocationConversionTable = ({ data = [] }) => {
  return (
    <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">Location Conversion</h3>
      </div>

      {data?.length ? (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase">Location</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase">Total Leads</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase">Sold Leads</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase">Conversion %</th>
                <th className="text-left py-3 px-2 text-xs font-semibold text-gray-500 uppercase">Progress</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, index) => {
                const conversion = Number(row?.conversionRate || 0);
                const safeWidth = Math.max(0, Math.min(100, conversion));

                return (
                  <tr key={`${row?.label || 'location'}-${index}`} className="border-b border-gray-50">
                    <td className="py-3 px-2 text-gray-700">{row?.label || 'Unknown'}</td>
                    <td className="py-3 px-2 text-gray-700">{row?.totalLeads || 0}</td>
                    <td className="py-3 px-2 text-gray-700">{row?.soldLeads || 0}</td>
                    <td className="py-3 px-2 text-gray-700">{conversion.toFixed(2)}%</td>
                    <td className="py-3 px-2 min-w-[180px]">
                      <div className="h-2.5 rounded-full bg-gray-100">
                        <div
                          className="h-2.5 rounded-full bg-[#009ef7] transition-all duration-700"
                          style={{ width: `${safeWidth}%` }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="py-10 text-center text-sm text-gray-400">No conversion data available</div>
      )}
    </div>
  );
};

export default LocationConversionTable;
